import { render } from "./Status.vue?vue&type=template&id=772ecd17"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"

import exportComponent from "/Users/stanislavdmitriev/Projects/savvills/m.impwork/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__